import React from "react"
import { useTranslation } from "react-i18next"
import { PageMain } from "@puregym/ui"

import { HeadTitle } from "src/components/layout/headTitle"
import { MarketingPreferencesProvider } from "src/features/subscriptionCentre"

export const Layout: React.FCWithChildren = ({ children }) => {
  const { t } = useTranslation("marketingPreferences")
  return (
    <>
      <HeadTitle title={t("htmlPageTitle")} />
      <PageMain>
        <MarketingPreferencesProvider>{children}</MarketingPreferencesProvider>
      </PageMain>
    </>
  )
}
